import React from 'react';

class WebNav extends React.Component {
  componentDidMount() {
    const { secondaryNavData } = this.props;

    const applyPrimaryNavSignal = () => {
      const hudlLayout = document.querySelector('hudl-layout');
      if (!hudlLayout || !hudlLayout.shadowRoot) return;
      const webnav = hudlLayout.shadowRoot.querySelector('.hui-webnav');
      const unregisteredNav = hudlLayout.shadowRoot.querySelector('.hui-unregisterednav');
      if (!webnav) return;
      if (webnav.classList.contains('hui-webnav--has-no-teams') && !unregisteredNav) {
        document.body.classList.add('no-primary-nav');
      } else {
        document.body.classList.remove('no-primary-nav');
      }
    };

    const applyRedesignSignal = () => {
      const hudlLayout = document.querySelector('hudl-layout');
      if (!hudlLayout || !hudlLayout.shadowRoot) return false;
      const card = hudlLayout.shadowRoot.querySelector('.global-navigation-layout-card');
      if (!card) return false;
      document.documentElement.classList.add('has-redesign-nav');
      document.body.classList.add('has-redesign-nav');
      applyPrimaryNavSignal();
      return true;
    };

    const watchForRedesign = () => {
      if (applyRedesignSignal()) return;
      const hudlLayout = document.querySelector('hudl-layout');
      if (!hudlLayout || !hudlLayout.shadowRoot) return;

      applyPrimaryNavSignal();
      const observer = new MutationObserver(() => {
        if (applyRedesignSignal()) {
          observer.disconnect();
          return;
        }
        applyPrimaryNavSignal();
      });
      observer.observe(hudlLayout.shadowRoot, { childList: true, subtree: true, attributes: true });
      if (applyRedesignSignal()) {
        observer.disconnect();
      }
    };

    if (customElements.get('hudl-layout')) {
      watchForRedesign();
    } else {
      customElements.whenDefined('hudl-layout').then(watchForRedesign);
    }

    if (secondaryNavData) {
      const setNav = () => {
        const navEl = document.querySelector('hudl-layout');
        if (navEl) navEl.secondaryNavData = secondaryNavData;
      };
      if (customElements.get('hudl-layout')) {
        setNav();
      } else {
        customElements.whenDefined('hudl-layout').then(setNav);
      }
    }
  }

  render() {
    return (
      <div className="prof-flex-container">
        {this.props.children}
      </div>
    );
  }
}

WebNav.propTypes = {
  children: React.PropTypes.element,
  secondaryNavData: React.PropTypes.object,
};

export default WebNav;
